import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    GeneralTask,
    Organisation,
    PersonsOrganisationDto
} from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GeneralTaskAddDialogueComponent } from './add-task/general-task-add-dialogue.component';

@Injectable()
export class GeneralTasksDialoguesService {
    constructor(private modelService: BsModalService, private router: Router) {}

    showAddTaskDialogue(organisation: PersonsOrganisationDto) {
        return this.modelService.show(GeneralTaskAddDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-md',
            initialState: {
                organisation
            }
        });
    }

    showTaskDetailsDialogue(task: GeneralTask, organisation: Organisation) {
        this.router.navigate(['tasks', 'tasks', task.id], {
            queryParamsHandling: 'preserve'
        });
    }

    showTaskEditDialogue(task: GeneralTask, organisation: Organisation) {
        this.router.navigate(['tasks', 'tasks', task.id, 'edit'], {
            queryParamsHandling: 'preserve'
        });
    }
}
